import _extends from "@babel/runtime/helpers/extends";
import { forwardRef, createElement } from 'react';
import { isESModule } from './is-es-module';
import { isReactComponent, acceptsRef, wrapReactClass } from './is-react';
import { isObject } from './is-object';
export function accessLibrary(library) {
  if (typeof library !== 'string') {
    return library;
  }

  return window[library] || generateHtmlComp(library);
}
export function generateHtmlComp(library) {
  if (['a', 'img', 'div', 'span', 'svg'].includes(library)) {
    return /*#__PURE__*/forwardRef(function (props, ref) {
      return /*#__PURE__*/createElement(library, _extends({
        ref: ref
      }, props), props.children);
    });
  }
}
export function getSubComponent(library, paths) {
  var l = paths.length;

  if (l < 1 || !library) {
    return library;
  }

  var i = 0;
  var component;

  while (i < l) {
    var _key = paths[i];
    var ex = void 0;

    try {
      component = library[_key];
    } catch (e) {
      ex = e;
      component = null;
    }

    if (i === 0 && component == null && _key === 'default') {
      if (ex) {
        return l === 1 ? library : null;
      }

      component = library;
    } else if (component == null) {
      return null;
    }

    library = component;
    i++;
  }

  return component;
}

function findComponent(libraryMap, componentName, npm) {
  if (!npm) {
    return accessLibrary(componentName);
  } // libraryName the key access to global
  // export { exportName } from xxx exportName === global.libraryName.exportName
  // export exportName from xxx   exportName === global.libraryName.default || global.libraryName
  // export { exportName as componentName } from package
  // if exportName == null exportName === componentName;
  // const componentName = exportName.subName, if exportName empty subName donot use


  var exportName = npm.exportName || npm.componentName || componentName;
  var libraryName = libraryMap[npm["package"]] || exportName;
  var library = accessLibrary(libraryName);
  var paths = npm.exportName && npm.subName ? npm.subName.split('.') : [];

  if (npm.destructuring) {
    paths.unshift(exportName);
  } else if (isESModule(library)) {
    paths.unshift('default');
  }

  return getSubComponent(library, paths);
}
/**
 * 判断是否是一个混合组件，即 components 是一个对象，对象值是 React 组件
 * 示例：
 * {
 *    Button: ReactNode,
 *    Text: ReactNode,
 * }
 */


function isMixinComponent(components) {
  if (!isObject(components)) {
    return false;
  }

  return Object.keys(components).some(function (componentName) {
    return isReactComponent(components[componentName]);
  });
}

export function buildComponents(libraryMap, componentsMap, createComponent) {
  var components = {};
  Object.keys(componentsMap).forEach(function (componentName) {
    var component = componentsMap[componentName];

    if (component && component.componentName === 'Component') {
      components[componentName] = createComponent(component);
    } else if (isReactComponent(component)) {
      if (!acceptsRef(component)) {
        component = wrapReactClass(component);
      }

      components[componentName] = component;
    } else if (isMixinComponent(component)) {
      components[componentName] = component;
    } else {
      component = findComponent(libraryMap, componentName, component);

      if (component) {
        if (!acceptsRef(component)) {
          component = wrapReactClass(component);
        }

        components[componentName] = component;
      }
    }
  });
  return components;
}
export function getProjectUtils(librayMap, utilsMetadata) {
  var projectUtils = {};

  if (utilsMetadata) {
    utilsMetadata.forEach(function (meta) {
      var _meta$npm;

      if (librayMap[meta === null || meta === void 0 ? void 0 : (_meta$npm = meta.npm) === null || _meta$npm === void 0 ? void 0 : _meta$npm["package"]]) {
        var lib = accessLibrary(librayMap[meta === null || meta === void 0 ? void 0 : meta.npm["package"]]);

        if (lib !== null && lib !== void 0 && lib.destructuring) {
          Object.keys(lib).forEach(function (name) {
            if (name === 'destructuring') return;
            projectUtils[name] = lib[name];
          });
        } else if (meta.name) {
          projectUtils[meta.name] = lib;
        }
      }
    });
  }

  return projectUtils;
}